import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './styles/global.css';

if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event: Event) => {
    event.preventDefault();
    window.location.reload();
  });
}

const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
